import {useTranslation} from 'react-i18next';

import {useAppSelector} from 'hooks';
import {removePromotionVoucher} from 'services/basket/basket-service';
import SendBrowserEvent from 'services/send-browser-event';

export const useRemoveBasketVoucher = () => {
  const {idToken: accessToken} = useAppSelector((state) => state?.auth);
  const {t} = useTranslation();

  const removeVoucher = async (voucherId: string) => {
    if (!voucherId || !accessToken) {
      console.error('Missing voucherId or accessToken');
      return;
    }
    try {
      const result = await removePromotionVoucher(accessToken);
      if (result?.message) {
        SendBrowserEvent.showInfoToastEnabled(t('omniChannelVoucher.removeVoucherSuccess'));
        return result;
      }
    } catch (error) {
      console.error('Error removing voucher:', error);
      throw error;
    }
  };

  return {removeVoucher};
};
